
import React from 'react';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const SignOut = ({ redirectUrl = "/sign-in"}) => {
  const navigate = useNavigate();
  const { logout } = React.useContext(AuthContext);

  useEffect(() => {
    logout();
    // Redirect to sign-in after 1 seconds
    const timer = setTimeout(() => {
      navigate(redirectUrl, { replace: true });
    }, 1000);

    // Clear timeout if the component is unmounted before the redirect
    return () => clearTimeout(timer);
  }, [navigate, redirectUrl]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container
        component="main"
        maxWidth="md"
        sx={{ textAlign: 'center', py: 5 }}
      >
        <Typography>Redirecting to the Sign In page ...</Typography>
      </Container>
    </>
  );
};

export default SignOut;
